import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ActionSheetController,
  ActionSheetButton,
  NavController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'retail-carousel',
  templateUrl: './retail-carousel.component.html',
  styleUrls: ['./retail-carousel.component.scss'],
})
export class RetailCarouselComponent implements OnInit {
  @Input() retailers: any;
  @Input() baseUrl: string;
  
  constructor(
    private navController: NavController,
    private analyticsService: AnalyticsService,
    private actionSheetController: ActionSheetController,
    private translate: TranslateService
  ) {}

  ngOnInit() {}

  navigate(item) {
    console.log('RetailCarouselComponent - navigate called with item:', item);
    if (item?.selectedLocation) {
      this.navController.navigateForward(
        this.baseUrl +
          '/' +
          item?.serviceid +
          '/' +
          item?.selectedLocation?.locationInfo?.locationName
      );
      this.analyticsService.trackUnified('retail_carousel_clicked', {
        flow: 'home',
        outcome: 'success',
        legacy_event_name: 'retail_carousel_clicked',
        component: 'retail-carousel-component',
        button: 'card',
      });
    } else {
      const locationNames = item?.locations
        ?.map((service) => service?.locationInfo?.locationName)
        .filter(Boolean);
      if (locationNames?.length > 0) {
        const actionSheetButtonList = locationNames.map((locationName) => {
          const actionSheetButton: any = {
            text: locationName,
            role: '',
            handler: () => {
              this.navController.navigateForward(
                this.baseUrl + '/' + item?.serviceid + '/' + locationName
              );
              this.analyticsService.trackUnified('retail_carousel_clicked', {
                flow: 'home',
                outcome: 'success',
                legacy_event_name: 'retail_carousel_clicked',
                component: 'retail-carousel-component',
                button: 'card',
              });
            },
          };
          return actionSheetButton;
        });
        this.openLocationSheet(actionSheetButtonList);
      } else {
        this.navController.navigateForward(
          this.baseUrl + '/' + item?.serviceid
        );
        this.analyticsService.trackUnified('retail_carousel_clicked', {
          flow: 'home',
          outcome: 'success',
          legacy_event_name: 'retail_carousel_clicked',
          component: 'retail-carousel-component',
          button: 'card',
        });
      }
    }
  }

  async openLocationSheet(actionSheetButtonList?: ActionSheetButton[]) {
    this.analyticsService.trackUnified('location_filter_opened', {
      flow: 'home',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      button: 'across-airport-button',
    });
    const actionSheetButton: ActionSheetButton = {
      text: this.translate.instant('action_sheet.close'),
      role: 'cancel',
      handler: () => {},
    };
    actionSheetButtonList.push(actionSheetButton);
    const actionSheet = await this.actionSheetController.create({
      header: this.translate.instant('action_sheet.filter_by_location'),
      cssClass: 'custom-sheet',
      buttons: actionSheetButtonList,
    });
    await actionSheet.present();
  }
}
